import { FunctionalComponent, h } from 'preact';
import { useCallback } from 'preact/hooks';
import SharedLocationActions from '../../shared-location-actions/shared-location-actions';
import { useTranslation } from '../../../hooks/use-translation';
import { AddressProps } from '../select-pickup/address/address';
import ActionModal, { ModalState } from '../../action-modal/action-modal';
import Modal from '../../modal/modal';

interface Props {
	onOk: () => void;
	onCancel: () => void;
	address: AddressProps;
	state: ModalState;
	isOpen: boolean;
	loading: boolean;
}

const getAddressComponent = (t, address: AddressProps) => {
	return (
		<span>
			<div className="sub-title">{`${t('REDIRECT_PICKUP.TO')}:`}</div>
			<div className="address">{address.address}</div>
			<div className="description">{address.description}</div>
		</span>
	);
};

const ConfirmPickupLocationModal: FunctionalComponent<Props> = ({
	onOk,
	onCancel,
	address,
	state,
	isOpen,
	loading
}) => {
	const { t } = useTranslation();

	const getContent = useCallback(() => {
		return (
			<div className="confirm-pickup-location-modal-content" data-testid="confirm-pickup-location-modal-content">
				<div className="title">{t('REDIRECT_PICKUP.CONFIRM_TITLE')}</div>
				{getAddressComponent(t, address)}
				<SharedLocationActions onOk={onOk} onCancel={onCancel} className="confirm-pickup-location-actions" />
			</div>
		);
	}, []);

	return (
		<span className="confirm-pickup-location-modal" data-testid="confirm-pickup-location-modal">
			<Modal isOpen={isOpen}>
				<ActionModal
					okText={t('REDIRECT_PICKUP.OK')}
					successTitle={t('REDIRECT_PICKUP.SUCCESS_TITLE')}
					errorTitle={t('REDIRECT_PICKUP.FAILED_TITLE')}
					errorDescription={t('REDIRECT_PICKUP.FAILED_DESCRIPTION')}
					closeModal={onCancel}
					modalState={state}
					successContent={getAddressComponent(t, address)}
					children={getContent()}
					isLoading={loading}
				/>
			</Modal>
		</span>
	);
};

export default ConfirmPickupLocationModal;
